import { ActionKeys } from '~/actions/constants';
import * as ItemActions from '~/actions/item.actions';
import { call, takeLatest } from 'redux-saga/effects';
import * as itemServices from '~/services/item.service';

export function* getItem(action: ReturnType<typeof ItemActions.fetchItems>) {
  try {
    const response = yield call(itemServices.fetchItem, action.payload.query, action.payload.page);
    action.callback(response.data);
  } catch (err) {
    action.callback(err);
  }
}

export default [takeLatest(ActionKeys.FETCH_ITEMS, getItem)];
